export class ChatNotificationHistoryFilterEntity {
  isRead?: boolean
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
  driverUserId?: string
}
